import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // `window.scrollTo` works across browsers and in JSDOM; `Element.scrollTo`
    // is missing on `document.body` in some test environments.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
